import {
  ADD_REFERRAL,
  ADD_REFERRAL_SUCCESS,
  ADD_REFERRAL_FAIL,
  GET_REFERRAL,
  GET_REFERRAL_SUCCESS,
  GET_REFERRAL_FAIL,
  UPDATE_REFERRAL,
  UPDATE_REFERRAL_SUCCESS,
  UPDATE_REFERRAL_FAIL
} from "./actionTypes"

export const addReferral = referral => ({
  type: ADD_REFERRAL,
  payload: referral
})

export const addReferralSuccess = referral => ({
  type: ADD_REFERRAL_SUCCESS,
  payload: referral,
})

export const addReferralFail = error => ({
  type: ADD_REFERRAL_FAIL,
  payload: error,
})

export const getReferral = ( username) => ({
  type: GET_REFERRAL,
  payload: username
})

export const getReferralSuccess = referral => ({
  type: GET_REFERRAL_SUCCESS,
  payload: referral,
})

export const getReferralFail = error => ({
  type: GET_REFERRAL_FAIL,
  payload: error,
})

export const updateReferral = referral => ({
  type: UPDATE_REFERRAL,
  payload: referral
})

export const updateReferralSuccess = referral => ({
  type: UPDATE_REFERRAL_SUCCESS,
  payload: referral,
})

export const updateReferralFail = error => ({
  type: UPDATE_REFERRAL_FAIL,
  payload: error,
})


